<template>
  <label class="m-0 px-4 py-3 focus-within_ring-2 flex gap-2 items-center cursor-text" :for="`${name}-search`">
    <FontAwesomeIcon class="flex-shrink-0" icon="magnifying-glass" :class="modelValue ? 'text-current' : 'text-gray-400'" />
    <input
      :id="`${name}-search`"
      type="search"
      class="bg-transparent placeholder-gray-400 p-0 focus_outline-none flex-grow min-w-0 text-current border-0 focus_[box-shadow:none]"
      :placeholder="placeholder"
      :value="modelValue"
      :disabled="disabled"
      @input="emitInputValue"
    />
    <button v-if="modelValue" type="button" class="appearance-none" @click="$emit('update:modelValue', '')">
      <XMarkIcon class="flex-shrink-0 w-4 h-4 text-white" />
    </button>
  </label>
</template>

<script lang="ts" setup>
import { XMarkIcon } from '@heroicons/vue/24/outline'
import type { Booleanish } from '~/entities'

defineProps({
  name: {
    type: String,
    required: true,
  },
  modelValue: {
    type: String,
    required: true,
  },
  disabled: {
    type: [Boolean, String] as PropType<Booleanish>,
    default: () => false,
  },
  placeholder: {
    type: String,
    default: 'Search by Keyword',
  },
})

const emit = defineEmits(['update:modelValue'])

function emitInputValue(event: Event) {
  emit('update:modelValue', (event.target as HTMLInputElement).value)
}
</script>

<style lang="stylus" scoped>
input:empty
  @apply whitespace-nowrap overflow-ellipsis overflow-hidden
</style>
